import React from 'react'
import {MdOutlineMail} from 'react-icons/md'
import {BsWhatsapp} from 'react-icons/bs'
import {RiMessengerLine} from 'react-icons/ri'
import "./Contact.css"
import react,{useRef} from 'react'
import emailjs from 'emailjs-com'


function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    
    e.preventDefault();

    emailjs.sendForm('service_lph6vf5', 'template_8qubyer', form.current, '60a-RSoyP6aPUEulg')
      .then((result) => {

          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
  };


 const Notification=()=>{
 
const time =setTimeout(() => {
  document.location.reload();
}, 5000);
 
 alert('Your message sent successfully',time)
 
  
 }
 
 
 
  
 
 








  return (
    


     
  
     
      
      
      
      
      
    
  
    <section id='container contact-container'>
      <section id='contact'>
<h5>Get In Touch</h5>
<h2>Contact Me</h2>

<div  className='container contact-container'>
<div className='contact-options'>
<article className='contact-option'>
    <MdOutlineMail/>
<h4>Email</h4>



<a href='mailto:krniraj092001@gmail.com' target="_blank">Send a Message</a>

</article>

<article className='contact-option'>




<RiMessengerLine/>
<h4>Messenger</h4>
<a href='https://m.me/t/100072186483807' target="_blank">Send a Message</a>

</article>
<article className='contact-option'>
    <BsWhatsapp/>

    <h4>whatsapp</h4>

<a href='https://wa.me/+918290711012' target="_blank">Send a Message</a>

</article>



</div>
<form  ref={form} onSubmit ={sendEmail}>
<input type="text"  name='name' placeholder='Your Full Name' required />
<input type="email"  name='email' placeholder='Your Email' required />
<textarea name='message' rows= '7'   placeholder='Your Message' required />
<button type='submit' className='btn btn-primary' onClick={Notification}>send Message</button>



</form>


</div>


</section>

    </section>
      


    
  )
}

export default Contact
